import React, { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useGroupChatContext } from "../../../../../../context/groupchatContext";
import { locationsApi, useAddNurseMutation, useAddNurseToLocationMutation, useDeleteNursingHomeMutation, useGetNursesQuery, useMarkUnMarkNurseAdminMutation } from "../../../../../../services/location_services";
import { useForm, useWatch } from "react-hook-form";
import { InputField } from "../../../../../../components/reactHookFormFields/inputField";
import { MaskField } from "../../../../../../components/reactHookFormFields/maskField";
import { FaPencilAlt } from "react-icons/fa";
import { RiShieldCheckLine, RiShieldCheckFill } from "react-icons/ri";
import moment from "moment";
import ActionDialog from "../../../../../../components/actionDialog";
import { formatPhoneNumber, getCurrentEpochTime } from "../../../../../../utils/common_lib";
import { ReactSelectField } from "../../../../../../components/reactHookFormFields/selectField";
import { TableListing } from "../../../../../../components/AppListing/TableListing";
import { isDateValid } from "../../../../../../helper";
import { IoIosArrowDown, IoIosArrowBack } from "react-icons/io";
import { IoRemoveCircleOutline } from "react-icons/io5";
import { AsyncSelectField } from "../../../../../../components/reactHookFormFields/asyncSelectField";
import { phoneFormat } from "../../../../../../components/common";
import { GiPadlockOpen } from "react-icons/gi";
import { useDisable2FaMutation } from '../../../../../../services/chatService';
import MainPageDialog from "../../../../../../components/dialog";
import LocationCheckin from "../../../../../locationCheckin";
import ListIcon from "../../../../../../components/listIcon";
function LocationGroupNurses({ selectedLocation = {}, scrollToTop = () => { } }) {
  const { authData } = useGroupChatContext();

  const [showNurseForm, setShowNurseForm] = useState(true);
  const [defaultNursesList, setDefaultNursesList] = useState([]);
  const [saveSelectedNurseData, setSaveSelectedNurseData] = useState(null);
  const [editNurseCheck, setEditNurseCheck] = useState(false);
  const [confirmModalState, setConfirmModalState] = useState(false);
  const [selectedNurse, setSelectedNurse] = useState(null);
  const [isOpenCheckInPopup, setIsOpenCheckInPopup] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const { currentLocation } = selectedLocation;
  const dcTimestamp = useMemo(() => getCurrentEpochTime()?.milliseconds, [])

  // Form
  const { control, formState: { errors }, setValue, handleSubmit, getValues, clearErrors } = useForm({ defaultValues: { name: "", pincode: "", phone: "", username: "", password: "", email: "" } });

  // Queries & Mutations
  const { data: nursesListing, isLoading: nursesListingLoading, refetch: refetchNursesListing } = useGetNursesQuery({
    _dc: dcTimestamp,
    location_id: currentLocation.id,
    page: 1,
    start: 0,
    limit: 200,
  });
  const [searchNursesTrigger] = locationsApi.endpoints.getNurses.useLazyQuery();
  const [addNurseToLocationTrigger, { isLoading: addNurseToLocationLoading }] = useAddNurseToLocationMutation();
  const [addNurseTrigger, { isLoading: addingNurse }] = useAddNurseMutation();
  const [deleteNurseTrigger, { isLoading: deletingNurse }] = useDeleteNursingHomeMutation();
  const [markUnMarkNurseAdminTrigger, { isLoading: markingAdmin }] = useMarkUnMarkNurseAdminMutation();
  const [disable2Fa, { isLoading: isDisabling2Fa }] = useDisable2FaMutation();
  const [confirmationData, setConfirmationData] = useState({ isOpen: false })
  const cancelCallBackFun = () => setConfirmationData({ isOpen: false })

  function disbale2FaAPICall(item) {
    setConfirmationData({ isOpen: false })
    disable2Fa({ nurse_id: item.id }).then((res) => {
      if (res.data.code == 0) {
        refetchNursesListing();
        toast.success(res.data.msg)
      }
    })
  }
  const handleCheckInOut = (item) => {
    const userData = {
      user_id: item?.id,
      name: item?.name || item?.username,
      ...item,
    };
    setCurrentUser(userData);
    setIsOpenCheckInPopup(true);
  };

  const openConfirmationModal = (item) => {
    const title = `Are you sure you want to disable 2FA for <span class="font-bold">${item?.name}</span>?`;
    setConfirmationData({
    isOpen: true,
    title: title,
    callBackFun: () => disbale2FaAPICall(item),
    cancelCallBackFun: cancelCallBackFun
  })}

  // Watchers
  const phoneValue = useWatch({ control, name: "phone" });

  const cols = useMemo(() => ([
    { title: "Name", key: "name", colClass: "flex text-left" },
    {
      title: "Phone",
      key: "phone",
      colClass: "flex text-left",
      getData: (item) => item?.phone ? formatPhoneNumber(item?.phone) : "--",
    },
    { title: "Username", key: "username", colClass: "flex text-left" },
    { title: "Email", key: "email", colClass: "flex text-left", getData: (item) => item?.email || "--" },
    {
      title: "PIN Code",
      key: "pincode",
      colClass: "flex text-left",
      getData: (item) => item?.pincode || "--",
    },
   {
      title: "Last Updated On",
      key: "updated",
      colClass: "flex text-left",
      getData: (item) => isDateValid(item?.updated, "YYYY-MM-DD HH:mm:ss") ? moment(item?.updated, "YYYY-MM-DD HH:mm:ss").format("MM/DD/YYYY") : "N/A",
    },
    {
      title: "2-FA",
      key: "2fa",
      colClass: "flex text-left",
      getData: (item) => item?.two_factor_auth_enabled ? <span className="text-green-500">Enabled/<span className="uppercase">{item?.two_factor_auth_type}</span></span> : <span className="text-red-500">Disabled</span>,
    },
    {
      title: "Actions",
      getData: (item) => {
        return (
          <div className="flex gap-2">
            <span
              title="Edit"
              className="cursor-pointer"
              onClick={() => handleEditNurse(item)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleEditNurse(item);
                }
              }}
            >
              <FaPencilAlt color="#00acc1" />
            </span>
            <ListIcon
              title="Check-in/Check-out"
              handler={() => handleCheckInOut(item)}
              type="check-in"
              disabled={false}
            />
            {authData?.is_provider && (
              <span
                title={item?.is_facility_admin ? "Remove admin" : "Mark as admin"}
                className="cursor-pointer"
                onClick={() => handleToggleAdmin(item)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleToggleAdmin(item);
                  }
                }}
              >
                {item?.is_facility_admin ? (
                  <RiShieldCheckFill color="#00acc1" />
                ) : (
                  <RiShieldCheckLine color="#00acc1" />
                )}
              </span>
            )}
            {item?.two_factor_auth_enabled && (
              <span
                title="Disable 2FA"
                className="cursor-pointer"
                onClick={() => {
                  openConfirmationModal(item);
                }}
              >
                <GiPadlockOpen color="#00acc1" />
              </span>
            )}
            <span
              title="Remove"
              className="cursor-pointer"
              onClick={() => handleRemoveNurse(item)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleRemoveNurse(item);
                }
              }}
            >
              <IoRemoveCircleOutline color="#fc0505" />
            </span>

          </div>
        );
      },
    },
  ]), [])

  const handleToggleAdmin = (item) => {
    if (markingAdmin || deletingNurse || addingNurse) return;
    const newAdminStatus = !item?.is_facility_admin;
    markUnMarkNurseAdminTrigger({
      nurse_id: item?.id,
      location_id: currentLocation?.id,
      is_admin: newAdminStatus,
    })
      .then((res) => {
        const { code, msg } = res?.data || {};
        if (code === 0 || code === "0") {
          toast.success(msg || (newAdminStatus ? "Nurse marked as admin" : "Admin status removed"));
          refetchNursesListing();
        } else {
          toast.error(res?.data?.msg || "Failed to update admin status");
        }
      })
      .catch((err) => {
        console.log("Error toggling admin", err);
        toast.error("Error updating admin status");
      });
  };

  const searchNurse = useCallback(async (query) => {
    const _dcTimestamp = getCurrentEpochTime()?.milliseconds;
    const response = await searchNursesTrigger({
      _dc: _dcTimestamp,
      keyword: query || "",
      page: 1,
      start: 0,
      limit: 200,
    });

    const { code, data } = response?.data || {};
    let nursesList = [];

    if (code === 0 || code === "0") {
      nursesList = data?.map((item) => ({
        label: item?.name,
        ...item,
      })) || [];
    }

    // Remove duplicates based on `id`
    nursesList = Array.from(new Map(nursesList.map((item) => [item.id, item])).values());
    setDefaultNursesList(nursesList);

    return nursesList;
  }, [searchNursesTrigger]);

  const handleEditNurse = useCallback((item) => {
    scrollToTop();
    setEditNurseCheck(true);
    setSelectedNurse(item);
    clearErrors();
    setValue("name", item?.name);
    setValue("pincode", item?.pincode);
    setValue("phone", phoneFormat(item?.phone));
    setValue("username", item?.username);
    setValue("password", "");
    setValue("email", item?.email);
  }, [setEditNurseCheck, setSelectedNurse, setValue, clearErrors]);

  const handleSaveExistingNurse = useCallback(async () => {
    try {

      const payload = {
        body: {
          nurse_id: saveSelectedNurseData?.id,
          location_id: currentLocation?.id,
        }
      };

      await addNurseToLocationTrigger(payload)
        .then((res) => {
          const { code, msg } = res?.data || {};

          if (code === 0 || code === "0") {
            toast.success(msg || "Nurse added to location successfully");
            refetchNursesListing();
          }
        })
        .catch((err) => {
          console.log("err ", err);
          toast.error("Error while adding nurse to location");
        })
        .finally(() => {
          setSaveSelectedNurseData(null);
          setValue("nurse_id", "");
        });
    } catch (error) {
      toast.error("Error while adding nurse to location");
      console.log("error ", error);
    }
  }, [saveSelectedNurseData, addNurseToLocationTrigger, currentLocation?.id]);

  const handleRemoveNurse = useCallback((item) => {
    if (deletingNurse || addingNurse) return;
    setConfirmModalState(true);
    setSelectedNurse(item);
  }, [deletingNurse, addingNurse]);

  const onCancelHandler = useCallback(() => {
    setConfirmModalState(false);
    setSelectedNurse(null);
  }, [setConfirmModalState, setSelectedNurse]);

  const onConfirmHandler = useCallback(() => {
    try {
      const payload = {
        body: {
          location_id: currentLocation?.id,
          nurse_id: selectedNurse?.id,
        },
      };

      deleteNurseTrigger(payload)
        .then((res) => {
          const { code, data, msg } = res?.data;
          if (code === 0 || code === "0") {
            toast.success(msg || "Nurse removed successfully");
            refetchNursesListing();
          }
        })
        .catch((err) => {
          console.log("Error in delete nurse", err);
          toast.error("Error in delete nurse");
        })
        .finally(() => {
          onCancelHandler();
        });
    } catch (err) {
      console.log("Error calling delete nurse");
      toast.error("Error calling delete nurse");
    }
  }, [deletingNurse, addingNurse, onCancelHandler, currentLocation?.id, selectedNurse?.id]);

  const handleResetNurseForm = useCallback(() => {
    setValue("name", "");
    setValue("pincode", "");
    setValue("phone", "");
    setValue("username", "");
    setValue("password", "");
    setValue("email", "");
  }, [setValue]);

  const handleSaveNewNurse = useCallback(async (data) => {
    try {
      const payload = {
        body: {
          location_id: currentLocation?.id,
          name: data?.name,
          phone: data?.phone || " - ",
          username: data?.username,
          pincode: data?.pincode,
          email: data?.email,
        },
      };

      // Only include password if it's provided
      if (data?.password) {
        payload.body.password = data.password;
      }

      // Add id to payload if in edit mode
      if (editNurseCheck && selectedNurse?.id) {
        payload.body.id = selectedNurse.id;
      }

      addNurseTrigger(payload)
        .then((res) => {
          const { code, msg } = res?.data || {};
          if (code === 0 || code === "0") {
            toast.success((editNurseCheck ? "Nurse updated successfully" : msg || "Nurse added successfully"));
            handleResetNurseForm();
            refetchNursesListing();
            if (editNurseCheck) {
              setEditNurseCheck(false);
              setSelectedNurse(null);
            }
          }
        })
        .catch((err) => {
          console.log("Error in adding nurse", err);
          toast.error(editNurseCheck ? "Error in updating nurse" : "Error in adding nurse");
        })
    } catch (error) {
      toast.error("Error while adding nurse to location");
      console.log("error ", error);
    }
  }, [currentLocation?.id, addNurseTrigger, handleResetNurseForm, refetchNursesListing, editNurseCheck, selectedNurse]);

  const handleCancelEdit = useCallback(() => {
    handleResetNurseForm();
    setEditNurseCheck(false);
    setSelectedNurse(null);
  }, [handleResetNurseForm]);

  useEffect(() => {
    searchNurse("");
  }, []);

  return (
    <div className="flex flex-col gap-2 border-2 border-gray-100 rounded-md bg-slate-50 p-2">
      {isOpenCheckInPopup && (
        <MainPageDialog
          title={`New Check In or Check Out (${currentUser?.name || ""})`}
          onCancelHandler={() => {
            setIsOpenCheckInPopup(false);
            setCurrentUser(null);
          }}
          component={
            <LocationCheckin
              closeLocationApptPopup={() => {
                setIsOpenCheckInPopup(false);
                setCurrentUser(null);
              }}
              fromWhere="nurses_listing"
              currentUser={currentUser}
              currentLocation={currentLocation}
              refetchData={refetchNursesListing}
            />
          }
          footer={false}
        />
      )}
      {confirmModalState && (
        <ActionDialog
          onCancelHandler={onCancelHandler}
          setShowModal={onCancelHandler}
          onConfirmHandler={onConfirmHandler}
          showModal={confirmModalState}
          title="Are you sure you want to delete Nurse User?"
          headerTitle="Delete User?"
        />
      )}
      <ActionDialog
        onCancelHandler={() => {
          if (typeof confirmationData.cancelCallBackFun == 'function') {
            confirmationData.cancelCallBackFun()
          }
          else {
            setConfirmationData({ isOpen: false })
          }
        }
        }
        isHideCloseBtn={true}
        setShowModal={() => setConfirmationData({ isOpen: false })}
        onConfirmHandler={confirmationData?.callBackFun}
        showModal={confirmationData?.isOpen}
        title={confirmationData?.title}
        confirmButtonText="Yes"
      />
      <div className="p-2 bg-bgGreen text-white shadow-md flex items-center justify-between cursor-pointer" onClick={() => setShowNurseForm(!showNurseForm)}>
        <p className="text-left">Nursing Staff</p>
        {showNurseForm ? <IoIosArrowDown /> : <IoIosArrowBack />}
      </div>
      {showNurseForm ?
        <>
          <div className="flex gap-2 mt-2">
            <div className="flex flex-col gap-[10px] text-left w-full">
              <strong>Select Nurse:</strong>
              <form onSubmit={handleSubmit(handleSaveNewNurse)}>
                <div className="flex flex-wrap items-center gap-7 mt-2">
                  <div className="md:w-[31%] w-full">
                    <InputField
                      control={control}
                      name="name"
                      title="Enter Nurse Name"
                      type="text"
                      aria-label="Nurse Name"
                      errors={errors}
                      autoComplete="off"
                      rules={{
                        required: {
                          value: true,
                          message: "Please enter Full Name",
                        }
                      }}
                      onChange={(e) => {
                        try {
                          setValue("name", e.target.value.replace(/^\s+/, ""));
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                    />
                  </div>
                  <div className="md:w-[31%] w-full">
                    <InputField
                      control={control}
                      name="pincode"
                      title="Please enter PIN"
                      type="text"
                      aria-label="PIN Code"
                      autoComplete="off"
                      errors={errors}
                      onChange={(e) => setValue("pincode", e.target.value.match(/\d+/g) ? e.target.value.match(/\d+/g).join("").substring(0, 4) : "")}
                      rules={{
                        required: {
                          value: true,
                          message: "Please enter 4 digit PIN",
                        },
                        minLength: {
                          value: 4,
                        },
                        maxLength: {
                          value: 4,
                        },
                      }}
                    />
                  </div>
                  <div className="md:w-[31%] w-full">
                    <MaskField
                      mask="(999) 999-9999"
                      control={control}
                      name="phone"
                      title="Enter Mobile Number"
                      aria-label="Mobile Number:"
                      autoComplete="off"
                      errors={errors}
                      isDisabled={false}
                      rules={{
                        pattern: {
                          value: /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                          message: "Please enter a valid phone number",
                        },
                      }}
                      onChange={(e) => {
                        try {
                          setValue("phone", e.target.value.replace(/^\s+/, ""));
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                    />
                  </div>
                  <div className="md:w-[31%] w-full">
                    <InputField
                      control={control}
                      name="username"
                      title="Enter Username"
                      type="text"
                      aria-label="Username"
                      errors={errors}
                      autoComplete="off"
                      isDisabled={editNurseCheck}
                      rules={{
                        required: !phoneValue ? { value: true, message: "Username is required" } : false,
                      }}
                      onChange={(e) => {
                        try {
                          setValue("username", e.target.value.trim());
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                    />
                  </div>
                  <div className="md:w-[31%] w-full">
                    <InputField
                      control={control}
                      name="password"
                      title="Enter Password"
                      type="password"
                      aria-label="Password"
                      errors={errors}
                      autoComplete="off"
                      rules={{
                        required: !phoneValue && !editNurseCheck ? { value: true, message: " Please enter password" } : false,
                        pattern: {
                          value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                          message: "Must include 1 uppercase (A), 1 digit (0-9), and be 8 characters long.",
                        }
                      }}
                    />
                  </div>
                  <div className="md:w-[31%] w-full">
                    <InputField
                      control={control}
                      name="email"
                      title="Enter Email"
                      type="email"
                      autoComplete="off"
                      aria-label="Email"
                      errors={errors}
                      rules={{
                        required: !phoneValue ? { value: true, message: "Please enter a valid email address" } : false,
                        pattern: {
                          value: /^[\w.\-+]+@([\w\-]+\.)+[\w\-]{2,4}$/,
                          message: "Please enter a valid email address",
                        },
                      }}
                      onChange={(e) => {
                        try {
                          const email = e.target.value.trim();
                          const emailRegex = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~.-]+@([\w\-]+\.)+[\w\-]{2,4}$/;

                          if (emailRegex.test(email)) {
                            setValue("email", email);
                          } else {
                            console.warn("Invalid email format");
                          }
                        } catch (error) {
                          console.error(error);
                        }
                      }}
                    />
                  </div>
                  <div className="md:w-[31%] w-full flex items-center gap-2">
                    <button
                      type="submit"
                      aria-label={editNurseCheck ? "Update" : "Save"}
                      title={editNurseCheck ? "Update" : "Save"}
                      disabled={addingNurse}
                      className="flex gap-1 items-center bg-teal-500 text-white py-2 px-4 rounded-md hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-50 border text-md"
                    >
                      {editNurseCheck ? "Update" : "Save"}
                    </button>
                    {!editNurseCheck && (
                      <button
                        type="button"
                        aria-label="Reset"
                        title="Reset"
                        disabled={addingNurse || deletingNurse}
                        onClick={handleResetNurseForm}
                        className="flex gap-1 items-center bg-teal-500 text-white py-2 px-4 rounded-md hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-50 border text-md"
                      >
                        Reset
                      </button>
                    )}
                    {editNurseCheck && (
                      <button
                        type="button"
                        aria-label="Cancel"
                        title="Cancel"
                        onClick={handleCancelEdit}
                        className="flex gap-1 items-center bg-white text-gray-600 py-2 px-4 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 border text-md"
                      >
                        Cancel
                      </button>
                    )}
                  </div>
                </div>
              </form>
              <hr />
              <div className="flex flex-col gap-[10px]">
                <strong>Add Existing Nurse:</strong>
                <div className="grid grid-cols-12 gap-4 mt-2">
                  <div className="md:col-span-2 col-span-7">
                    <AsyncSelectField
                      name="nurse_id"
                      control={control}
                      errors={errors}
                      placeholder="Select Nurse:"
                      title="Select Nurse:"
                      menuPlacement="bottom"
                      search={searchNurse}
                      optionData={defaultNursesList}
                      onChange={setSaveSelectedNurseData}
                    />
                  </div>
                  <div className="md:col-span-2 col-span-4">
                    <div className="flex items-center gap-2">
                      <button
                        type="submit"
                        aria-label="Save"
                        title="Save"
                        onClick={handleSaveExistingNurse}
                        disabled={addNurseToLocationLoading}
                        className="flex gap-1 items-center bg-teal-500 text-white py-2 px-4 rounded-md hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-50 border text-md"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5 max-h-[400px] overflow-y-auto overflow-x-hidden w-[290px] md:w-auto">
            <TableListing
              listData={nursesListing?.data || []}
              cols={cols || []}
              pagination={false}
              loading={nursesListingLoading || isDisabling2Fa || markingAdmin || false}
            />
          </div>
        </>
        : null}
    </div>
  );
}

export default LocationGroupNurses;
